import { get, writable } from 'svelte/store'

import { browser } from '$app/environment'
import { makeCountry } from '$lib/factories'
import { apiFetchJson } from '$lib/proxy/apiProxy'
import type { Country } from '$lib/types/client_types'

const store = writable([] as Country[])
export { store as storeCountries }

let promiseFetch: Promise<Country[]>
let state: 'pending' | 'reading' | 'ready' = 'pending'

export async function InitCountries(pFetch = fetch) {
	if (!browser) return fetchData(pFetch)
	if (state === 'ready') return
	if (state === 'reading') {
		await promiseFetch
		return
	}
	promiseFetch = fetchData(pFetch)
	await promiseFetch
	return
}

async function fetchData(pFetch = fetch) {
	state = 'reading'

	const jsonData = await apiFetchJson(pFetch, 'get', '/lookup/countries')
	if (!jsonData || jsonData.error) {
		state = 'pending'
		return
	}

	const data = jsonData.countries
	if (browser) {
		store.set(data)
		state = 'ready'
	}

	return data
}

// UP generic ==== Down custom ===================

export function getCountry(country_id: string) {
	const allCountries = get(store)
	const country = getCountryFromArray(allCountries, country_id)
	return country
}

const getCountryFromArray = (countries: Country[], c: string, def = 'US') => {
	let ctry = countries.find((co) => co.id === c)

	if (ctry) return ctry

	ctry = countries.find((co) => co.id === def)

	if (ctry) return ctry

	//this should never happen
	return makeCountry()
}
